// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"f762d2c3","898":"4741a2dc"}[chunkId] + ".chunk.css";
};